import React from 'react';
import Text from "../../Components/Text";
import {format, parse} from 'date-fns';

const ClientDetails = (props) => {
    const {
        data = {
            'title':                                         '',
            'first_name':                                    '',
            'last_name':                                     '',
            'email':                                         '',
            'phone_prefix':                                  '',
            'phone_number':                                  '',
            'dual_nationality':                              '',
            'primary_nationality':                           '',
            'secondary_nationality':                         '',
            'date_of_birth':                                 '',
            'national_insurance_number':                     '',
            'occupation':                                    '',
            'residential_address_line_1':                    '',
            'residential_address_line_2':                    '',
            'residential_town_city':                         '',
            'residential_state_county':                      '',
            'residential_postcode':                          '',
            'residential_country':                           '',
            'residential_occupied_since_year':               '',
            'residential_occupied_since_month':              '',
            'permanent_address_is_correspondence_address':   '',
            'correspondence_address_line_1':                 '',
            'correspondence_address_line_2':                 '',
            'correspondence_town_city':                      '',
            'correspondence_state_county':                   '',
            'correspondence_postcode':                       '',
            'correspondence_country':                        '',
            'correspondence_occupied_since_year':            '',
            'correspondence_occupied_since_month':           '',
        },
    } = props;

    return (
        <React.Fragment>
            <div className={'row m-0 p-0'}>
                <div className={'col-sm-6 ps-0'}>
                    <Text className={'fw-bold'}>Full name:</Text>
                </div>
                <div className={'col-sm-6 ps-0'}>
                    <Text>{data.title} {data.first_name} {data.last_name}</Text>
                </div>

                <div className={'col-sm-6 ps-0'}>
                    <Text className={'fw-bold'}>Email address:</Text>
                </div>
                <div className={'col-sm-6 ps-0'}>
                    <Text>{data.email}</Text>
                </div>

                <div className={'col-sm-6 ps-0'}>
                    <Text className={'fw-bold'}>Phone number:</Text>
                </div>
                <div className={'col-sm-6 ps-0'}>
                    <Text>{data.phone_prefix} {data.phone_number}</Text>
                </div>

                <div className={'col-sm-6 ps-0'}>
                    <Text className={'fw-bold'}>{data.dual_nationality ? 'Nationalities:' : 'Nationality:'}</Text>
                </div>
                <div className={'col-sm-6 ps-0'}>
                    <Text>{data.dual_nationality ? `${data.primary_nationality}, ${data.secondary_nationality}` : data.primary_nationality}</Text>
                </div>

                <div className={'col-sm-6 ps-0'}>
                    <Text className={'fw-bold'}>Date of birth:</Text>
                </div>
                <div className={'col-sm-6 ps-0'}>
                    <Text>{data.date_of_birth}</Text>
                </div>

                <div className={'col-sm-6 ps-0'}>
                    <Text className={'fw-bold'}>Occupation:</Text>
                </div>
                <div className={'col-sm-6 ps-0'}>
                    <Text>{data.occupation}</Text>
                </div>

                <div className={'col-sm-6 ps-0'}>
                    <Text className={'fw-bold'}>National insurance number:</Text>
                </div>
                <div className={'col-sm-6 ps-0'}>
                    <Text>{data.national_insurance_number}</Text>
                </div>

                <div className={'col-sm-6 ps-0'}>
                    <Text className={'fw-bold'}>Current residential address:</Text>
                </div>
                <div className={'col-sm-6 ps-0'}>
                    <Text style={{marginBottom: 0}}>
                        {data.residential_address_line_1},{' '}<br/>
                        {data.residential_address_line_2 ? `${data.residential_address_line_2}, ` : ' '}<br/>
                        {data.residential_town_city},{' '}<br/>
                        {data.residential_state_county ? `${data.residential_state_county}, ` : ' '}<br/>
                        {data.residential_postcode},{' '}<br/>
                        {data.residential_country}
                    </Text>
                    <Text>(occupied since {format(new Date(data.residential_occupied_since_month), 'MMM',)} {data.residential_occupied_since_year})</Text>
                </div>

                {data.permanent_address_is_correspondence_address === 0 && (
                    <>
                        <div className={'col-sm-6 ps-0'}>
                            <Text className={'fw-bold'}>Do you want your permanent residential address to be your correspondence address:</Text>
                        </div>
                        <div className={'col-sm-6 ps-0'}>
                            <Text>No</Text>
                        </div>

                        <div className={'col-sm-6 ps-0'}>
                            <Text className={'fw-bold'}>Correspondence address:</Text>
                        </div>
                        <div className={'col-sm-6 ps-0'}>
                            <Text style={{marginBottom: 0}}>
                                {data.correspondence_address_line_1},{' '}<br/>
                                {data.correspondence_address_line_2 ? `${data.correspondence_address_line_2}, ` : ' '}<br/>
                                {data.correspondence_town_city},{' '}<br/>
                                {data.correspondence_state_county ? `${data.correspondence_state_county}, ` : ' '}<br/>
                                {data.correspondence_postcode},{' '}<br/>
                                {data.correspondence_country}
                            </Text>
                            <Text>(occupied since {format(new Date(data.correspondence_occupied_since_month), 'MMM',)} {data.correspondence_occupied_since_year})</Text>
                        </div>
                    </>
                )}
            </div>
        </React.Fragment>
    );
}

export default ClientDetails;
